import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';

import { useModalsContext } from '../../contexts/ModalsContext';

import styles from '../../../styles/modals/modals.module.scss';

interface ModalsContainerProps {
    className?: string;
}

function ModalsContainer({ className = null }: ModalsContainerProps) {
    const { modals, setContainer } = useModalsContext();
    const containerRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        setContainer(containerRef.current);
    }, []);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.modals,
                    {
                        [styles.hasModals]: modals.length > 0,
                    },
                ])}
                ref={containerRef}
            />
        </div>
    );
}

export default ModalsContainer;
